export const possibleTypes = {
  ProductEditorialValue: ['ProductEditorialLink', 'ProductEditorialText'],
};
